export default "__VITE_ASSET__Q0rjTAHk__"